export default __webpack_public_path__ + "static/media/Shop-3.2b16c8ab.webp";